import { render } from "./ElementCreateSelection.vue?vue&type=template&id=3c5b7aac&scoped=true&ts=true"
import script from "./ElementCreateSelection.vue?vue&type=script&lang=ts"
export * from "./ElementCreateSelection.vue?vue&type=script&lang=ts"

import "./ElementCreateSelection.vue?vue&type=style&index=0&id=3c5b7aac&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5b7aac"]])

export default __exports__